import { useRef, useState } from 'react';
import classes from './Checkout.module.css';

const isEmpty = value => value.trim() === '';
const isNotFiveChars = value => value.trim().length !== 5;

const Checkout = (props) => {
    const [formInputValid, setFormInputValid] = useState({
        name:true,
        street:true,
        city:true,
        postalcode:true

    })

    const nameInputRef = useRef('');
    const streetInputRef = useRef('');
    const postalInputRef = useRef('');
    const cityInputRef = useRef('');

    const confirmHandler = (event) => {
        event.preventDefault();
        const enteredName = nameInputRef.current.value 
        const enteredStreet = streetInputRef.current.value
        const enteredPostal = postalInputRef.current.value
        const enteredCity = cityInputRef.current.value

        const enteredNameIsValid = !isEmpty(enteredName)
        const enteredStreetIsValid = !isEmpty(enteredStreet)
        const enteredCityIsValid = !isEmpty(enteredCity)
        const enteredPostalIsValid = !isNotFiveChars(enteredPostal)

        setFormInputValid({
            name: enteredNameIsValid,
            street: enteredStreetIsValid,
            city: enteredCityIsValid,
            postalcode: enteredPostalIsValid
        })

        const formIsValid = enteredNameIsValid && enteredStreetIsValid && enteredPostalIsValid && enteredCityIsValid

        if(!formIsValid){
            return
        }
        props.onConfirm({
            name: enteredName,
            street: enteredStreet,
            city: enteredCity,
            postalcode: enteredPostal
        })
    };
  

    return (
        <form className={classes.form} onSubmit={confirmHandler}>
        <div className={`${classes.control} ${formInputValid.name ? '' : classes.invalid}`}>
            <label htmlFor='name'>Your Name</label>
            <input type='text' id='name' ref={nameInputRef} />
            {!formInputValid.name && <p>Please Enter a Valid Name</p>}
        </div>
        <div className={`${classes.control} ${formInputValid.street ? '' : classes.invalid}`}>
            <label htmlFor='street'>Street</label>
            <input type='text' id='street' ref={streetInputRef}/>
            {!formInputValid.street && <p>Please Enter a Valid street</p>}
        </div>
        <div className={`${classes.control} ${formInputValid.postalcode ? '' : classes.invalid}`}>
            <label htmlFor='postal'>Postal Code</label>
            <input type='text' id='postal' ref={postalInputRef} />
            {!formInputValid.postalcode && <p>Please Enter a Valid Postal Code</p>}
        </div>
        <div className={`${classes.control} ${formInputValid.city ? '' : classes.invalid}`}>
            <label htmlFor='city'>City</label>
            <input type='text' id='city' ref={cityInputRef} />
            {!formInputValid.city && <p>Please Enter a Valid City</p>}
        </div>
        <div className={classes.actions}>
            <button type='button' onClick={props.onCancel}>
            Cancel
            </button>
            <button className={classes.submit}>Confirm</button>
        </div>
        </form>
    );
};

export default Checkout;